import ProductController from '@/assets/controllers/ProductController'
import DifferentiatedPricesController from '@/assets/controllers/DifferentiatedPricesController'
import LocaleController from '@/assets/controllers/LocaleController'
import CashbackCampaingController from '@/assets/controllers/CashbackCampaingController'
import Util from '@/assets/libs/util'
import eventModule from '@/assets/libs/eventModule'
import IdentifiedConsumerController from '@/assets/controllers/IdentifiedConsumerController'
import Vue from 'vue'
import SuggestionsController from '@/assets/controllers/SuggestionsController'
import ClarityController from '@/assets/controllers/ClarityController'

let cart = []
let pagerCode = null
let pedidoComanda = null
let bandeiraCartao = null
let digitalWalletName = null
let comandasAgregadas = []
let appliedDiffPrices = false
let backupCart = []
let unavailableProductsObj = {}
let unavailableProductsObjBkp = {}
let sequence = 0
let consumerName = ''

const getProductPrice = function (product) {
    if ((Util.isTapMode() || Util.isBalancaMode()) && product.itemValue) {
        return product.itemValue
    } else if (Util.isBalancaMode() || product.insertedByEan13) {
        if (Number.isInteger(product.quantity)) {
            return Math.round(product.quantity * product.totalItemPrice * 100) / 100 // product.quantity * product.totalItemPrice
        }
        return Math.floor(product.quantity * product.totalItemPrice * 100) / 100 // product.quantity * product.totalItemPrice
    } else {
        return Math.round(product.quantity * product.totalItemPrice * 100) / 100 // product.quantity * product.totalItemPrice
    }
}

const applyDifferentiatedPrices = async function () {
    if (hasAppliedDiffPrices()) return false // se ja tiver aplicado o preço diferenciado nn faça nada
    // console.log('Aplicando preços diferenciados')
    let backupCartIsEmpty = backupCart && backupCart.length === 0
    if (backupCartIsEmpty) {
        backupCart = Util.deepCopy(cart)
    }

    try {
        let diffPrices = Util.deepCopy(DifferentiatedPricesController.getDiffPrices())
        await setDiffPricesOnCart(diffPrices)
        setAppliedDiffPrices(true)
        // console.log(cart)
    } catch (error) {
        console.log(error.message)
        restoreOriginalPrices()
    }
}

const ungroupItemAndApplyDiscount = async function (product, diffPrices) {
    return new Promise((resolve, reject) => {
        // console.log(`O produto ${product.productName} será desagrupado para aplicar preço diferenciado unico a um dos itens`)
        let newProduct = Util.deepCopy(product)
        newProduct.quantity = 1
        product.quantity = product.quantity - 1
        handleFatherNewPrices(newProduct, diffPrices)
        ProductController.priceUpdate(newProduct)
        cart.push(newProduct)
        resolve()
    })
}

const setDiffPricesOnCart = async function (diffPrices) {
    return new Promise((resolve, reject) => {
        cart.forEach(async (product) => {
            await handleFatherNewPrices(product, diffPrices)
            ProductController.priceUpdate(product)
            resolve()
        })
    })
}

const replacePrices = function (product, newPrices) {
    product.hasAppliedDiffPrices = true
    product.addition = newPrices.addition
    product.discount = newPrices.discount
    product.fullPrice = newPrices.fullPrice
    product.price = newPrices.price
    if (product.totalItemPrice !== undefined) {
        product.totalItemPrice = Math.max(0.01, newPrices.price || 0)
    }
}

const handleFatherNewPrices = async function (product, diffPrices) {
    let hasDiffPrice = diffPrices.hasOwnProperty(product.productCode)

    if (hasDiffPrice) {
        let newPrices = diffPrices[product.productCode]
        if (product.quantity > 1 && product.price > 0 && newPrices.uniqueDiscount === true) {
            await ungroupItemAndApplyDiscount(product, diffPrices)
        } else {
            // console.log(`${product.productName} possui preço diferenciado`)
            replacePrices(product, newPrices)
            if (newPrices.uniqueDiscount) delete diffPrices[product.productCode]
        }
    }

    let hasObservations = product.observations && product.observations.length > 0
    if (hasObservations) {
        handleFatherObservations(product, diffPrices)
    }

    let hasChildProds = product.productCombo && product.productCombo.length > 0
    if (hasChildProds) {
        await handleChildNewPrices(product, diffPrices)
    }
}

const handleFatherObservations = async function (product, diffPrices) {
    product.observations.forEach(async obs => {
        let obsIsProduct = obs.obsProductCode != null
        if (obsIsProduct) {
            let obsHasDiffPrice = diffPrices.hasOwnProperty(obs.obsProductCode)
            if (obsHasDiffPrice) {
                // console.log(`${obs.obsName} possui preço diferenciado`)
                let obsNewPrices = diffPrices[obs.obsProductCode]
                if (obsNewPrices.uniqueDiscount === true && product.quantity > 1) {
                    await ungroupItemAndApplyDiscount(product, diffPrices)
                } else {
                    replacePrices(obs, obsNewPrices)
                    if (obsNewPrices.uniqueDiscount === true) delete diffPrices[obs.obsProductCode]
                }
            }
        }
    })
}

const handleChildNewPrices = async function (product, diffPrices) {
    product.productCombo.forEach(async childProd => {
        let childHasDiffPrice = diffPrices.hasOwnProperty(childProd.subItemCode)

        if (childHasDiffPrice) {
            let childNewPrices = diffPrices[childProd.subItemCode]
            let applyInCombo = childNewPrices.applyInCombo === 'S'
            if (applyInCombo) {
                if (product.quantity > 1 && childNewPrices.uniqueDiscount === true) {
                    await ungroupItemAndApplyDiscount(product, diffPrices)
                } else {
                    // console.log(`${childProd.subItemName} possui preço diferenciado`)
                    replacePrices(childProd, childNewPrices)
                    if (childNewPrices.uniqueDiscount === true) delete diffPrices[childProd.subItemCode]
                }
            }
        }

        let hasObservations = childProd.observations && childProd.observations.length > 0
        if (hasObservations) {
            await handleChildObservations(childProd, diffPrices, product)
        }

        let isComboDoCombo = childProd.choosen
        if (isComboDoCombo) {
            await handleComboDoComboNewPrices(childProd, diffPrices, product)
        }
    })
}

const handleChildObservations = async function (childProd, diffPrices, product) {
    childProd.observations.forEach(async obs => {
        let obsIsProduct = obs.subItemObsProductCode != null
        if (obsIsProduct) {
            let obsHasDiffPrice = diffPrices.hasOwnProperty(obs.subItemObsProductCode)

            if (obsHasDiffPrice) {
                let obsNewPrices = diffPrices[obs.subItemObsProductCode]
                let applyInCombo = obsNewPrices.applyInCombo === 'S'

                if (applyInCombo) {
                    if (obsNewPrices.uniqueDiscount === true && product && product.quantity > 1) {
                        await ungroupItemAndApplyDiscount(product, diffPrices)
                    } else {
                        // console.log(`${obs.subItemObsName} possui preço diferenciado`)
                        replacePrices(obs, obsNewPrices)
                        if (obsNewPrices.uniqueDiscount === true) delete diffPrices[obs.subItemObsProductCode]
                    }
                }
            }
        }
    })
}

const handleComboDoComboNewPrices = async function (childProd, diffPrices, product) {
    let keys = Object.keys(childProd.choosen)

    keys.forEach(async key => {
        let keyHasItems = childProd.choosen[key] && childProd.choosen[key].length > 0

        if (keyHasItems) {
            childProd.choosen[key].forEach(async comboDoComboChild => {
                let comboDoComboChildHasDiffPrice = diffPrices.hasOwnProperty(comboDoComboChild.subItemCode)

                if (comboDoComboChildHasDiffPrice) {
                    let comboDoComboChildNewPrices = diffPrices[comboDoComboChild.subItemCode]
                    let applyInCombo = comboDoComboChildNewPrices.applyInCombo === 'S'

                    if (applyInCombo) {
                        if (comboDoComboChildNewPrices.uniqueDiscount === true && product && product.quantity > 0) {
                            await ungroupItemAndApplyDiscount(product, diffPrices)
                        } else {
                            // console.log(`${comboDoComboChild.subItemName} possui preço diferenciado`)
                            replacePrices(comboDoComboChild, comboDoComboChildNewPrices)
                            if (comboDoComboChildNewPrices.uniqueDiscount === true) delete diffPrices[comboDoComboChild.subItemCode]
                        }
                    }
                }

                let hasObservations = comboDoComboChild.observations && comboDoComboChild.observations.length > 0
                if (hasObservations) {
                    await handleChildObservations(comboDoComboChild, diffPrices, product)
                }
            })
        }
    })
}

const restoreOriginalPrices = function () {
    // console.log('Removendo preços diferenciados e aplicando preços gerais')
    cart = Util.deepCopy(backupCart)
    backupCart = []
    unavailableProductsObj = unavailableProductsObjBkp
    unavailableProductsObjBkp = {}
    setAppliedDiffPrices(false)
}

const setAppliedDiffPrices = function (booleanValue) {
    appliedDiffPrices = booleanValue
}

const hasAppliedDiffPrices = function () {
    return appliedDiffPrices
}

const setUnavailableProducts = function (unavailableProducts) {
    unavailableProductsObj = unavailableProducts
    unavailableProductsObjBkp = Util.deepCopy(unavailableProductsObj)
}

const getUnavailableProducts = function () {
    return unavailableProductsObj
}

const checkAllUnavailableProducts = function () {
    /* verifica se todos os produtos podem ser vendidos */
    let result = false
    if (unavailableProductsObj) {
        Object.keys(unavailableProductsObj).forEach((e) => {
            if (unavailableProductsObj[e].quantity > unavailableProductsObj[e].quantityAvailable) {
                result = true
                return true
            }
        })
    }
    return result
}

const changeQttyUnavailableProducts = function (product, operation) {
    /* operation sum, sub, del */
    let productCode = product.productCode
    if (unavailableProductsObj[productCode]) {
        let objQtt = unavailableProductsObj[productCode].quantity
        if (operation === 'sum') {
            unavailableProductsObj[productCode].quantity++
        } else {
            unavailableProductsObj[productCode].quantity = operation === 'del' ? (objQtt -= product.quantity) : (objQtt - 1)
        }
    }
    if (product.observations && product.hasProductUnavailable) {
        product.observations.forEach((obs) => {
            if (unavailableProductsObj[obs.obsProductCode]) {
                let objQtt = unavailableProductsObj[obs.obsProductCode].quantity
                if (operation === 'sum') {
                    unavailableProductsObj[obs.obsProductCode].quantity++
                } else {
                    unavailableProductsObj[obs.obsProductCode].quantity = operation === 'del' ? (objQtt -= product.quantity) : objQtt - 1
                }
            }
        })
    }
    if (product && product.productCombo && product.hasProductUnavailable) {
        changeQttyCombo(product.productCombo, operation, product.quantity)
    }
    eventModule.$emit('updateHasQuantityExceeded')
}

function getQtty (qtProdFhather, qtProdSon) {
    qtProdFhather = qtProdFhather ? parseFloat(qtProdFhather) : parseFloat(1)
    qtProdSon = qtProdSon ? parseFloat(qtProdSon) : parseFloat(1)
    return qtProdFhather * qtProdSon
}

function getProductsComboCombo (choosen) {
    let combos = []
    if (choosen) {
        Object.keys(choosen).forEach((e) => {
            choosen[e].forEach((c) => {
                if (c.unavailable) {
                    combos.push(c)
                }
            })
        })
    }
    return combos
}

function changeQttyCombo (combo, operation, fatherQtty) {
    if (!fatherQtty) fatherQtty = 1
    combo.forEach(prodC => {
        if (unavailableProductsObj[prodC.subItemCode]) {
            let objQtt = unavailableProductsObj[prodC.subItemCode].quantity
            if (operation === 'sum') {
                unavailableProductsObj[prodC.subItemCode].quantity += getQtty(1, prodC.quantity)
            } else {
                unavailableProductsObj[prodC.subItemCode].quantity = operation === 'del' ? (objQtt - getQtty(fatherQtty, prodC.quantity)) : (objQtt - getQtty(1, prodC.quantity))
            }
        }
        if (prodC.observations && prodC.hasProductUnavailable) {
            prodC.observations.forEach((obsC) => {
                if (unavailableProductsObj[obsC.subItemObsProductCode]) {
                    let objQtt = unavailableProductsObj[obsC.subItemObsProductCode].quantity
                    if (operation === 'sum') {
                        unavailableProductsObj[obsC.subItemObsProductCode].quantity += getQtty(1, prodC.quantity)
                    } else {
                        unavailableProductsObj[obsC.subItemObsProductCode].quantity = operation === 'del' ? (objQtt - getQtty(fatherQtty, prodC.quantity)) : objQtt -= getQtty(1, prodC.quantity)
                    }
                }
            })
        }
        if (prodC.choosen && prodC.hasProductUnavailable) {
            let comboCombo = getProductsComboCombo(prodC.choosen)
            changeQttyCombo(comboCombo, operation, fatherQtty)
        }
    })
}

export default {
    applyDifferentiatedPrices,
    restoreOriginalPrices,
    setAppliedDiffPrices,
    hasAppliedDiffPrices,
    setComanda: (_pedidoComanda) => {
        if (comandasAgregadas.length === 0) {
            pedidoComanda = _pedidoComanda
        }
        comandasAgregadas.push(_pedidoComanda)
    },
    getComanda: () => pedidoComanda,

    getComandasAgregadas: function () {
        return comandasAgregadas
    },

    getMainComandaAgregada: function () {
        if (comandasAgregadas && comandasAgregadas[0]) {
            return comandasAgregadas[0]
        }
        return {}
    },

    filterComanda: function (saleCode) {
        comandasAgregadas = comandasAgregadas.filter(ca => ca.saleCode !== saleCode)
        cart = cart.filter(ct => ct.comandaNumber !== saleCode)
    },

    getCart: function () {
        return cart
    },

    overrideCart: function (newCart) {
        cart = newCart
    },

    getPagerCode: function () {
        return pagerCode
    },

    setPagerCode: function (code) {
        pagerCode = code
        // (`pagerCode inserido: ${pagerCode}`)
    },

    getConsumerName: function () {
        return consumerName
    },

    setConsumerName: function (name) {
        consumerName = name
    },

    getbandeiraCartao: function () {
        return bandeiraCartao
    },

    setbandeiraCartao: function (code) {
        bandeiraCartao = code
    },

    clearbandeiraCartao: function () {
        bandeiraCartao = null
        // console.log(`Bandeira do Cartão Apagada`)
    },

    getDigitalWalletName: function () {
        return digitalWalletName
    },

    setDigitalWalletName: function (name) {
        digitalWalletName = name
    },

    clearDigitalWalletName: function () { // CartController.clearDigitalWalletName()
        digitalWalletName = null
        // console.log(`Nome da Carteira Digital Apagado`)
    },

    isCartEmpty: function () {
        return cart.length === 0
    },
    calculateQuantity: function (product, comboQuantity, fatherQuantity) {
        comboQuantity = comboQuantity || 1
        fatherQuantity = fatherQuantity || 1
        let productQuantity = product.quantity || 1
        let quantity = (productQuantity * comboQuantity * fatherQuantity)
        return quantity
    },
    calculateItemPrice: function (product) {
        let value = getProductPrice(product)
        return Util.formatMoney(value)
    },
    calculateItemComboPrice: function (comboItem, fatherQuantity) {
        let quantity = (comboItem.quantity === fatherQuantity ? fatherQuantity : (comboItem.quantity * fatherQuantity)) || fatherQuantity
        let comboItemPrice = comboItem.price
        let value = quantity * comboItemPrice
        return Util.formatMoney(value)
    },
    calculateObservationPrice: function (observation, comboQuantity, fatherQuantity) {
        comboQuantity = comboQuantity || 1
        fatherQuantity = fatherQuantity || 1
        let productQuantity = observation.quantity || 1
        let quantity = (productQuantity * comboQuantity * fatherQuantity)
        let observationPrice = observation.price || observation.subItemObsPrice
        let value = quantity * observationPrice
        return Util.formatMoney(value)
    },
    getTotalSubgroupDiscount: function () {
        const cart = this.getCart()
        let total = 0
        cart.forEach(item => {
            total += item.discount || 0
            const children = item.productCombo || item.childItems || []
            children.forEach(child => {
                total += child.discount || 0
            })
        })
        return parseFloat(total.toFixed(2))
    },

    // Retorna uma String com o valor total do carrinho, formatada no formato de dinheiro
    calculateTotalPrice: function (noServiceTax = false, showDiscount = true) {
        let totalPrice = 0
        let CRMDiscount = CashbackCampaingController.getDiscountApplied().value || 0

        cart.forEach((product) => {
            totalPrice += getProductPrice(product)
        })

        if (showDiscount) {
            if (CRMDiscount) totalPrice -= CRMDiscount
        }

        if (comandasAgregadas && comandasAgregadas[0] && comandasAgregadas[0].serviceTax !== null && !noServiceTax) {
            let serviceTax = comandasAgregadas.reduce((sum, ca) => sum + parseFloat(ca.serviceTax || 0), 0)
            totalPrice += serviceTax
        }

        return Util.formatMoney(totalPrice)
    },

    getTotalPriceAsFloat: function (noServiceTax = false, showDiscount = true) {
        let cartTotalString = this.calculateTotalPrice(noServiceTax, showDiscount)
        let cartTotal = cartTotalString.replace('R$', '').replace(',', '').replace('.', '').trim()
        return parseFloat(cartTotal) / 100
    },

    decreaseQtty: function (key, self) {
        if (cart[key].quantity > 1) {
            cart[key].quantity--
            ClarityController.event('usuario_diminiu_quantidade_produto')
            ClarityController.setTag('quantidade_produto_diminiuida', cart[key].quantity + 'x ' + cart[key].productName)
            if (!Util.isTapMode()) changeQttyUnavailableProducts(cart[key], 'sub')
        } else {
            this.deleteProduct(key, self)
            ClarityController.event('usuario_removeu_produto_do_carrinho')
            ClarityController.setTag('produto_removido', cart[key].productName)
        }
    },

    increaseQtty: function (key) {
        cart[key].quantity++
        ClarityController.event('usuario_aumentou_quantidade_produto')
        ClarityController.setTag('quantidade_produto_aumentada', cart[key].quantity + 'x ' + cart[key].productName)
        if (!Util.isTapMode()) {
            changeQttyUnavailableProducts(cart[key], 'sum')
        }
    },

    editProduct: function (product, key) {
        cart[key] = product
    },

    navigateToCheckout: function (router) {
        const { campaignEnabled } = CashbackCampaingController.getDiscountApplied()
        if (campaignEnabled === 5) {
            CashbackCampaingController.clearData()
        }
        if (cart.length > 0) {
            router.push('checkout')
        }
    },

    navigateToHome: function (router) {
        router.push('home')
    },

    navigateToPayment: function (router) {
        router.push('payment')
    },

    navigateToPager: function (router) {
        router.push('pager')
    },

    navigateToConsumer: function (router) {
        router.push('consumer')
    },

    fixProdForCart: function (prod) {
        if (!(prod.quantity && prod.unitValue && prod.totalItemPrice && prod.observations) && !prod.productCombo) {
            prod.quantity = prod.quantity || 1
            prod.unitValue = prod.price
            prod.totalItemPrice = prod.itemValue || Util.safeDecimalCalc(prod.unitValue, prod.discount, '-')
            prod.observations = prod.observations || []
            prod.productCombo = prod.productCombo || []
        }

        if (prod.isABox || prod.isertedByBarCode) {
            if (!prod.productCode && prod.subItemCode) prod.productCode = prod.subItemCode
            if (!prod.productName && prod.subItemName) prod.productName = prod.subItemName
            if (!prod.productPrint && prod.subItemProductPrint) prod.productPrint = prod.subItemProductPrint
            if (!prod.productImage && prod.subItemProductImage) prod.productImage = prod.subItemProductImage
            if (!prod.productImages && prod.subItemProductImages) prod.productImages = prod.subItemProductImages
        }

        return prod
    },

    addToCart: function (prod) {
        prod.index = cart.length
        cart.push(this.fixProdForCart(prod))
        ClarityController.event('usuario_adicionou_produto_ao_carrinho')
        ClarityController.setTag('produto_adicionado_ao_carrinho', prod.quantity + 'x ' + prod.productName)
    },

    // Esta funcao é usada para limpeza de carrinho decorrente de acoes do usuario
    clearCart: function (self, route) {
        let msg = Util.isTapMode() ? LocaleController.getString('deseja_cancelar_pagamento') : LocaleController.getString('deseja_limpar_carrinho')
        Util.showConfirmationDialog(self.$modal, () => {
            ClarityController.event('usuario_limpou_carrinho')
            Util.reloadcachedConfigs()
            cart = []
            backupCart = []
            pagerCode = null
            consumerName = ''
            SuggestionsController.resetSuggestionsController()
            self.$router.push(route)
        }, msg)
    },

    // Esta funcao é usada para limpeza de carrinho decorrente de acoes do sistema
    resetCart: function () {
        cart = []
        backupCart = []
        unavailableProductsObj = {}
        unavailableProductsObjBkp = {}
        pagerCode = null
        comandasAgregadas = []
        consumerName = ''
        SuggestionsController.resetSuggestionsController()
    },

    clearCartAndNavigateHome (router) {
        try {
            this.resetCart()
            Vue.nextTick(() => {
                router.push('/').catch(err => {
                    console.error('Erro ao navegar para home:', err)
                })
            })
        } catch (error) {
            console.error('Erro ao limpar carrinho:', error)
        }
    },

    deleteProduct: function (key, self) {
        let message = LocaleController.getString('certeza_que_deseja_remover') + `${cart[key].productName}` + LocaleController.getString('do_carrinho')
        Util.showConfirmationDialog(self.$modal, () => {
            if (!Util.isTapMode()) {
                changeQttyUnavailableProducts(cart[key], 'del')
            }
            ClarityController.event('usuario_removeu_produto_do_carrinho')
            ClarityController.setTag('produto_removido', cart[key].productName)
            cart.splice(key, 1)

            SuggestionsController.resetSuggestionsController()

            if (this.isCartEmpty()) {
                self.$router.push('Home')
            } else {
                self.$emit('reloadPrice')
            }
        }, message)
    },
    recalculateCart: function () {
        if (cart.length > 0) {
            cart.forEach(product => {
                ProductController.priceUpdate(product)
            })
        }
    },
    setUnavailableProducts,
    getUnavailableProducts,
    checkAllUnavailableProducts,
    clearCartData: () => {
        cart = []
        backupCart = []
        unavailableProductsObj = {}
        unavailableProductsObjBkp = {}
        pagerCode = null
        comandasAgregadas = []
        sequence = 0
        consumerName = ''
        DifferentiatedPricesController.clearDiffPrices()
        IdentifiedConsumerController.userLogout()
        IdentifiedConsumerController.clearConsumerData()
        SuggestionsController.resetSuggestionsController()
    },
    setProductSequence: function (product, cartIndex, productGroupIndex = 0, productIndex = 0, cComboIndex = 0) {
        if (!product.sequence) {
            if (cartIndex === null) {
                sequence++
            }
            let newSequence = sequence + '' + this.zeroLeft(productGroupIndex) + '' + this.zeroLeft(productIndex) + '' + this.zeroLeft(cComboIndex)
            product.sequence = newSequence
        }
    },
    zeroLeft: function (value) {
        return value.toString().padStart(3, '0')
    }
}



// WEBPACK FOOTER //
// ./src/assets/controllers/CartController.js